"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gradients = void 0;
var _primitives = require("./primitives");
/**
 * CSS gradient strings for web surfaces. Mobile uses the raw
 * `gradientStops` (or the palette's *GradientStart/End keys) with
 * expo-linear-gradient instead.
 */
const gradients = exports.gradients = {
  session: `linear-gradient(135deg, ${_primitives.gradientStops.session.start} 0%, ${_primitives.gradientStops.session.end} 100%)`,
  lap: `linear-gradient(135deg, ${_primitives.gradientStops.lap.start} 0%, ${_primitives.gradientStops.lap.end} 100%)`,
  sharedLaps: `linear-gradient(135deg, ${_primitives.gradientStops.sharedLaps.start} 0%, ${_primitives.gradientStops.sharedLaps.end} 100%)`
};